import React, { useId } from 'react';
import { InformationCircleIcon as InfoIcon } from '@heroicons/react/24/outline';
import { Tooltip } from 'react-tooltip';
import { classnames } from '@/utils/classnames/classnames';
import { InfoTooltipProps } from './types';

const InfoTooltip = ({
  children,
  content,
  icon,
  place = 'bottom-start',
  style = {},
  iconWidth = 20,
  iconHeight = 20,
  className = '',
  hideIcon,
  ...props
}: React.PropsWithChildren<InfoTooltipProps>) => {
  const id = useId();

  const Icon = icon ?? InfoIcon;

  return (
    <div   {...(hideIcon && {
      'data-tooltip-id': id,
      'data-tooltip-content': content,
    })} className={classnames('flex items-center gap-2', className)}>
      {children}
     {!hideIcon&&<Icon width={iconWidth} height={iconHeight} data-tooltip-id={id} data-tooltip-content={content} />} 
      <Tooltip id={id} place={place} style={{ zIndex: 10, ...style }} {...props} />
    </div>
  );
};

export default InfoTooltip;
